import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
  UPDATE_PROFILE,
  UPDATE_PROFILEPW,
} from "./actionTypes.js";

import {
  // getProfileSuccess,
  // getProfileFail,
  updateProfileSuccess,
  updateProfileFail,
  updateProfilePWSuccess,
  updateProfilePWFail,
} from "./actions.js"

import {
  // profileApi,
  updateProfile,
  updateProfilePW,
} from "./profileApi.js"

// function* fetchProfile() {
//   try {
//     const response = yield call(profileApi)
//     yield put(getProfileSuccess(response))
//   } catch (error) {
//     yield put(getProfileFail(error))
//   }
// }

function* onUpdateProfile({ payload: profile }) {
  try {
    const response = yield call(updateProfile, profile)
    yield put(updateProfileSuccess(response))
  } catch (error) {
    yield put(updateProfileFail(error))
  }
}

function* onUpdateProfilePW({ payload: profile }) {
  try {
    const response = yield call(updateProfilePW, profile)
    yield put(updateProfilePWSuccess(response))
  } catch (error) {
    yield put(updateProfilePWFail(error))
  }
}

function* ProfileSaga() {
  // yield takeEvery(GET_PROFILE, fetchProfile)
  yield takeEvery(UPDATE_PROFILE, onUpdateProfile)
  yield takeEvery(UPDATE_PROFILEPW, onUpdateProfilePW)

}

export default ProfileSaga
